module.exports = __webpack_public_path__ + "img/leaf_white.f825cd03.svg";